import React from 'react'
import '../../../../App.scss';
import Grid from "@material-ui/core/Grid";
import {connect} from "react-redux";
import LightImage from '../../../../assets/images/img_progress_light.png'

class TrainingProgress extends React.Component {
    constructor() {
        super()
        this.state = {
            rxDataLoaded: false,
            interval: null,
            loaderPercentage: 3,
        }
    }

    componentDidMount() {
        this.setState({
            loaderPercentage: this.props.max
        })
    }

    render() {
        let {current, max,text} = this.props.data
        return (
            <Grid className="progress" alignItems={"center"} style={{position: 'relative', height: '100%'}} container
                  justify={"center"}
            >
                {
                    current!==max ?(
                        <>
                            <Grid item className="progressbar" justify={"flex-start"} container alignItems={"center"}>
                              <span style={{
                                  // width:`${100/this.state.loaderPercentage}%`
                                  width: `${(100 / max) * (current)}%`
                              }}>
                              </span>
                                {/*<img style={{alignSelf:'center'}} className="progress-light-icon" src={LightImage} alt=""/>*/}
                            </Grid>
                            <p className="progress-text" style={{left: '5%', fontSize: '2vh'}}>
                                {max} / {current}
                            </p>
                        </>
                    ):(
                        <>
                            <Grid item container alignItems={"center"} justify={"center"}>

                                <p style={{fontSize: '1.2vh'}}>
                                    {text}
                                </p>
                            </Grid>
                        </>
                    )
                }


            </Grid>
        )
    }
}

export default (TrainingProgress)